import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import { AppVerticalProvider } from '@cred/shared/AppVerticalContext'

import RichCta from 'components/rich-cta'
import PersonalLoanForm from 'components/form/personal'
import WidgetPage from 'components/hocs/widget-page'
import withApolloProvider from 'components/hocs/withApolloProvider'

const RichCtaAppNoHoc = ({ utms, ...props }) => (
  <AppVerticalProvider vertical="pl">
    <RichCta
      url={`${config.credibleRoot}/personal-loan-prequalification`}
      formUrl={`${config.credibleRoot}/personal-loans/borrower`}
      title="Compare personal loan rates from top lenders"
      body="Loans for paying off credit cards, debt consolidation, home improvement and more."
      ctaText="Get Started"
      form={PersonalLoanForm}
      utms={utms}
      {...props}
    />
  </AppVerticalProvider>
)

RichCtaAppNoHoc.propTypes = {
  utms: PropTypes.object,
}

export default WidgetPage(withApolloProvider(RichCtaAppNoHoc))
